import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class SettingsService {

  constructor(private http: HttpClient) { }

  get() {
    return this.http.get('/api/settings');
  }

  edit(data) {
    return this.http.put('/api/settings', data);
  }

}



// WEBPACK FOOTER //
// ./client/app/core/settings/settings.service.ts